import React from "react";

import CollectGraphics from "components/collect-graphics";
import { Wraps } from "components/layout";
import { localizeIt } from "components/service/localize";
import { useMe, useVarParam } from "components/use-hooks";

const CollectGraphicsPage = () => {
    const appParams = useVarParam(),
        { me } = useMe();

    const { filter } = CollectGraphics.Hooks.useFilter({
        filter: {
            where: {
                eeId: {
                    column: "EE_ID",
                    operator: "EQ",
                    value: me.eeCurrentId
                }
            }
        }
    });

    appParams.set({
        headerTitle: localizeIt("PAGE.Title_CollectGraphics"),
        bottomBar: true
    });

    return (
        <Wraps.Container className="page collect-graphics-page">
            <CollectGraphics.Blocks.Filter
                filter={filter}
            />
            <CollectGraphics.Grids.All
                filter={filter.data}
            />
        </Wraps.Container>
    );
}

export default CollectGraphicsPage;